export default __webpack_public_path__ + "static/FootLogo-d31570455acbb1e934f785565ab7f9d9.png";